export enum ResultType {
  HOTEL = 'HOTEL',
  MESSAGING = 'MESSAGING',
  CAROUSEL = 'CAROUSEL'
}
